// extracted by mini-css-extract-plugin
export var clip = "MiniaturePost-module--clip--TdlGK";
export var end = "MiniaturePost-module--end--kFE+P";
export var line = "MiniaturePost-module--line--2BKcv";
export var post = "MiniaturePost-module--post--D-no6";
export var publishedOn = "MiniaturePost-module--publishedOn--8ieLL";
export var readMore = "MiniaturePost-module--readMore--CGL+9";